import { render, staticRenderFns } from "./Mail.vue?vue&type=template&id=42cdd392&scoped=true&"
var script = {}
import style0 from "./Mail.vue?vue&type=style&index=0&id=42cdd392&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cdd392",
  null
  
)

export default component.exports